/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Repeat Icon component.
 */
export const RepeatIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_19730)'>
        <path d='M7.85205 4.49658L9.49658 2.71149L7.85205 1.0002' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M1.77441 5.61883V2.9585C1.77441 2.68235 1.99827 2.4585 2.27441 2.4585H8.82438' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
        <path d='M4.14795 7.50342L2.50342 9.28851L4.14795 10.9998' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M10.2256 6.38117V9.0415C10.2256 9.31765 10.0017 9.5415 9.72559 9.5415H3.17562' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      </g>
      <defs>
        <clipPath id='clip0_14304_19730'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RepeatIcon;
